import * as React from 'react';
import { useBoolean } from 'ahooks';
import { InboxCustom } from '@archipro-design/icons';
import { useStyles } from '@archipro-design/aria';
import PinOverlayButton from '@modules/design-board/component/shared/PinOverlayButton';
import cx from 'classnames';
import * as S from '@modules/design-board/component/shared/TileTopActionButtons.desktop.style';
import { useCommentDialog } from '~/modules/build-hub-comment/hooks/useCommentDialog';
import { cn } from '@rocco/utils/cn';

interface CommentButtonProps {
    itemId: number;
    commentsCount?: number;
    inline?: boolean;
    onClick?: (e: React.SyntheticEvent<HTMLElement>) => void;
    className?: string;
}

export function CommentButton({
    itemId,
    commentsCount,
    inline,
    onClick,
    className,
}: CommentButtonProps) {
    const { css } = useStyles();
    const [tooltipState, tooltipAction] = useBoolean(false);
    const { openDialog, commentDialog } = useCommentDialog();

    const onClickComment = (e: React.SyntheticEvent<HTMLElement>) => {
        e.stopPropagation();
        e.preventDefault();

        if (onClick) {
            onClick(e);
        } else {
            openDialog(itemId);
        }
    };

    // ensure strictly boolean
    const showCount = (commentsCount ?? 0) > 0;
    const displayCount =
        commentsCount && commentsCount > 9 ? '9+' : commentsCount?.toString();

    if (inline) {
        return (
            <>
                <button
                    onClick={onClick ?? onClickComment}
                    className={cn(
                        'flex items-center justify-center rounded-full p-1 transition-colors',
                        'hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50',
                        className
                    )}
                    aria-label="Vote down"
                >
                    <div className="flex size-6 items-center justify-center">
                        <InboxCustom
                            className="mr-1 h-4 w-5"
                            style={{ width: '1.25rem', height: '1rem' }}
                        />
                    </div>
                    <span className="text-sm leading-4">{commentsCount}</span>
                </button>

                {commentDialog()}
            </>
        );
    }

    return (
        <>
            <div className="relative inline-block">
                <PinOverlayButton
                    className={cx(
                        css(S.CommentButton),
                        css(S.MessageToolTipStyle)
                    )}
                    open={tooltipState}
                    booleanActions={tooltipAction}
                    onClick={onClickComment}
                    icon={<InboxCustom />}
                    toolTipText={'Comment'}
                />
                {showCount && (
                    <span
                        className={cx(
                            'absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[8px] font-bold text-white'
                        )}
                    >
                        {displayCount}
                    </span>
                )}
            </div>
            {commentDialog()}
        </>
    );
}
